module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/321.fbb96548.png";